<svg enable-background="new 0 0 100 100" id="L6" version="1.1" viewBox="0 0 100 100" x="0px"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px" *ngIf="loader">
  <defs>
    <linearGradient
      [attr.x1]="loader.linearGradientPosition.x1"
      [attr.x2]="loader.linearGradientPosition.x2"
      [attr.y1]="loader.linearGradientPosition.y1"
      [attr.y2]="loader.linearGradientPosition.y2"
      id="linear">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </linearGradient>
    <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                    [attr.fy]="loader.radialGradientPosition.y"
                    id="radial">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </radialGradient>
  </defs>
  <rect [attr.stroke]="loader.color" fill="none" height="50" stroke-width="4" width="50" x="25" y="25">
  <animateTransform
    attributeName="transform"
    attributeType="XML"
    begin="rectBox.end"
    dur="0.5s"
    from="0 50 50"
    id="strokeBox"
    to="180 50 50"
    type="rotate"/>
  </rect>
  <rect [attr.fill]="loader.color" height="50" width="46" x="27" y="27">
  <animate
    attributeName="height"
    attributeType="XML"
    begin="0s;strokeBox.end"
    dur="1.3s"
    fill="freeze"
    from="50"
    id="rectBox"
    to="0"/>
  </rect>
</svg>
